// @flow
import styled from '@emotion/styled'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import { IconArrowBigLeft } from '../icons/IconArrow'
import * as text from '../text'

type Props = {
  children: React.Node,
  logoWidth: [string, string],
  className?: string,
  onClose: () => void,
}

const ExpandedMenu = React.forwardRef<Props, any>(
  ({ className, children, logoWidth, onClose }, forwardedRef) => {
    const [open, setOpen] = React.useState(!!children)

    React.useEffect(() => {
      setOpen(!!children)
    }, [children])

    return (
      <Root
        ref={forwardedRef}
        open={open}
        logoWidth={logoWidth}
        className={className}
      >
        <StyledMenu>
          <StyledGoBack
            tabIndex={0}
            role="button"
            onClick={() => {
              onClose()
              setOpen(false)
            }}
          >
            <IconArrowBigLeft color={colors.darkPurple} />
            <span>Back</span>
          </StyledGoBack>
          <ContentWrapper>{children}</ContentWrapper>
        </StyledMenu>
      </Root>
    )
  }
)

const Root = styled<{
  className?: string,
  children: React.Node,
  logoWidth: [string, string],
  open: boolean,
}>('div')`
  width: 100%;
  position: absolute;
  background: ${(p) => p.theme.background};
  padding-left: 20px;
  padding-right: 20px;
  overflow: hidden;
  visibility: ${(p) => (p.open ? 'visible' : 'hidden')};

  ${media.mq[2]} {
    padding-left: calc(20px + ${(p) => p.logoWidth[1]} + 30px);
  }
`

const StyledGoBack = styled.div`
  display: flex;
  padding-top: 20px;
  align-items: center;
  cursor: pointer;

  & > span {
    margin-left: 20px;
    ${text.paragraph3};
    color: ${colors.darkPurple};
  }

  svg {
    width: 30px;
  }

  ${media.mq[1]} {
    display: none;
  }
`

const StyledMenu = styled.div`
  flex-direction: column;
  display: flex;

  ${media.mq[1]} {
    display: block;
    max-width: 1200px;
  }
`

const ContentWrapper = styled.div`
  padding-top: 27px;

  min-height: calc(100vh - 64px);

  ${media.mq[1]} {
    padding-top: 15px;
    min-height: inherit;
  }
`

export default ExpandedMenu
